import React from "react";
import { siteData } from "../mock";
import { Award, HeartHandshake, Home as HomeIcon, Sparkles } from "lucide-react";

const icons = [Award, HeartHandshake, Sparkles, HomeIcon];

export default function Badges() {
  return (
    <section className="container-tight pb-16">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {siteData.badges.map((b, i) => {
          const Icon = icons[i];
          return (
            <div
              key={i}
              className="bg-white rounded-2xl p-6 border border-[#eee5d6] flex flex-col items-center text-center gap-3 hover:border-[#c76d4b]/50 hover:shadow-md transition-all"
            >
              <div className="w-12 h-12 rounded-xl bg-[#f5ead9] flex items-center justify-center flex-shrink-0">
                <Icon size={22} className="text-[#c76d4b]" />
              </div>
              <div>
                <div className="font-serif font-semibold text-[#2b2620] text-[15px] leading-snug">{b.label}</div>
                <div className="text-xs text-[#5c554c] mt-1.5 leading-relaxed">{b.desc}</div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
